<div class="d-flex mt-3">
  <div class="form-inline d-flex align-items-center">
    <div class="btn-group" btnRadioGroup khA11yRadioGroup [khA11yLabel]="accessibleLabel" [(ngModel)]="value" (ngModelChange)="notifyChanged()">
      <label *ngFor="let option of options"
              class="btn"
              [khA11yRadio]="value == option.value"
              [class.btn-primary]="value == option.value"
              [class.btn-default]="value != option.value"
              [btnRadio]="option.value"
              [khA11yRadio]="value == option.value"
              [khA11yRadioTabindex]="getOptionTabindex(option)"
              [khA11yLabel]="option.label"
              >{{option.label}}</label>
    </div>
  </div>
</div>